import { changeLocaleForUrl } from './route';

require('dotenv').config();

const baseURL = process.env.FRONTBASE_URL;
const baseLocale = 'en';

const languages = process.env.FRONTBASE_LANGUAGES.split(',');

const defaultTitle = 'Home';
const defaultDescription = 'Welcome to the world of operas, artists, composers';

export default function seo({ title, description, canonical, locale, ogTitle }) {
  const alternativeLang = languages.map(language => ({
    hrefLang: language,
    href: changeLocaleForUrl(canonical, locale, language),
  }));

  alternativeLang.push({
    hrefLang: 'x-default',
    href: changeLocaleForUrl(canonical, locale, 'en'),
  });

  return {
    title: title || defaultTitle,
    description: description || defaultDescription,
    canonical: canonical || `${baseURL}/${baseLocale}`,
    languageAlternates: alternativeLang,
    openGraph: {
      title: ogTitle || title || defaultTitle,
      description: description || defaultDescription,
      url: canonical || `${baseURL}/${baseLocale}`,
      type: 'website',
      locale,
      site_name: 'Operabase',
      images: [
        {
          url: `${baseURL.replace(/\/$/, '')}/images/operabase-logo-large.png`,
        },
      ],
    },
    twitter: {
      title: ogTitle || title || defaultTitle,
      description: description || defaultDescription,
      card: 'summary_large_image',
      site: '@BaseOpera',
      creator: '@BaseOpera',
    },
    additionalMetaTags: [
      {
        name: 'msapplication-TileColor',
        content: '#f36d2a',
      },
      {
        name: 'msapplication-TileImage',
        content: `${baseURL.replace(/\/$/, '')}/images/favicon/mstile-144x144.png`,
      },
      {
        name: 'theme-color',
        content: '#ffffff',
      },
    ],
  };
};
